import React, { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import customHttp from "../services/customHTTP";

// Create the AuthContext
const AuthContext = createContext();

// Custom hook for using the AuthContext
export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);
	const [needsEulaAcceptance, setNeedsEulaAcceptance] = useState(false);
	const [needsEmailVerification, setNeedsEmailVerification] = useState(false);
	const navigate = useNavigate();

	// Load session data on initial mount
	useEffect(() => {
		const token = sessionStorage.getItem("token");
		const userData = sessionStorage.getItem("user");

		if (token && userData) {
			setUser(JSON.parse(userData));
		}
		setLoading(false);
	}, []);

	const sendOtp = async (user_id) => {
		try {
			const response = await customHttp.post("/auth/send-otp", {
				user_id: user_id,
			});
			return response.data;
		} catch (error) {
			console.error("Error sending OTP:", error);
			return null;
		}
	};

	const login = async (token, userData, user_meta_data) => {
		const expirationTime = Date.now() + 8 * 60 * 60 * 1000; // 8 hours from now
		setUser({ ...userData, ...user_meta_data });
		sessionStorage.setItem("token", token);
		sessionStorage.setItem("user", JSON.stringify({ ...userData, ...user_meta_data }));
		sessionStorage.setItem("sessionExpiration", expirationTime);

		console.log("userData", { ...userData, ...user_meta_data });
		console.log("user_meta_data", user_meta_data);
		// if (user_meta_data.first_login) {
		// 	navigate("/accept-eula");
		// } else if (!user_meta_data.email_verified) {
		// 	await sendOtp(userData.user_id);
		// 	console.log("email_verified");
		// 	navigate("/verify-email");
		// } else {
		console.log("home");
		navigate("/home");
		// }
	};

	const logout = () => {
		sessionStorage.clear();
		setUser(null);
		navigate("/login");
	};

	const checkSessionExpiration = () => {
		const expirationTime = sessionStorage.getItem("sessionExpiration");
		if (expirationTime && Date.now() > Number(expirationTime)) {
			// Session has expired
			logout();
		}
	};

	const updateUserStatus = async (user_meta_data) => {
		setUser({ ...user, ...user_meta_data });
		sessionStorage.setItem("user", JSON.stringify({ ...user, ...user_meta_data }));
	};

	useEffect(() => {
		checkSessionExpiration();
		const interval = setInterval(checkSessionExpiration, 5 * 60 * 1000); // Check every 5 minutes
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const value = {
		user,
		loading,
		login,
		logout,
		sendOtp,
		isAuthenticated: !!user,
		updateUserStatus,
	};

	return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
};

export default AuthProvider;
